import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Market } from './market.service';



export interface Company {
    id: number;
    name: string;
    code: string;
    markets: Market[];
}

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    private readonly http = inject(HttpClient);

    private readonly baseUrl =
        '/api/v1/companies';

    getCompanies(): Observable<Company[]> {
        return this.http.get<Company[]>(
            this.baseUrl
        );
    }

    getCompany(
        id: number
    ): Observable<Company> {
        return this.http.get<Company>(
            `${this.baseUrl}/${id}`
        );
    }

    deleteCompany(
        id: number
    ): Observable<void> {
        return this.http.delete<void>(
            `${this.baseUrl}/${id}`
        );
    }

    
}